import 'custom-event-polyfill';
import { debounce, isFunction, isElement, head } from 'lodash';
import { EVENT_NAME } from './constants';
import { trackCbReceived } from './track';

export const withAnalytics = (data, options) => (cb) => {
  const analyticsCb = generateAnalyticsCb(data, options);
  return (...args) => {
    analyticsCb(...args);
    return cb(...args);
  };
};

const getData = (data, args) => (isFunction(data) ? data(...args) : data);

export const generateAnalyticsCb = (data = {}, { sectioned = false, debounce: wait = 0 } = {}) => {
  const fn = sectioned
    ? (...args) => {
        let node;
        if (isElement(head(args))) {
          node = args.shift();
        }
        const targetElement = node || (window.event && window.event.target);
        targetElement && targetElement.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: getData(data, args), bubbles: true }));
      }
    : (...args) => {
        track({ eventData: getData(data, args) });
      };

  return wait ? debounce(fn, wait) : fn;
};

export const track = (data) => {
  trackCbReceived.then((track) => {
    track(data);
  });
};
